var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-status"},[_c('v-chip',_vm._b({staticClass:"text-uppercase",attrs:{"color":_vm.payload.color,"text-color":_vm.payload.textColor,"label":""}},'v-chip',_vm.$attrs,false),[(!_vm.isLoading)?_c('span',[_vm._v(" "+_vm._s(_vm.payload.label)+" ")]):_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }